import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {GithubPicker} from 'react-color';

import useModal from 'hooks/useModal';
import Modal from 'components/Modal';
import useColor from 'hooks/useColor';
import useDomino from 'hooks/useDomino';
import useSetting from 'hooks/useSetting';
import useGroup from 'hooks/useGroup';

function ModalChooseColorToSwitch(props) {
	const {t} = useTranslation();
	let {
		forceOpen = false,
		currentZoom
	} = props;
	const [colorStart, setColorStart] = useState(false);
	const [colorEnd, setColorEnd] = useState(false);
	const [currentPalette, setCurentPalette] = useState(0);

	const {
		isShowing,
		hide,
		show,
	} = useModal();

	const {
		switchColor,
		getLineAndColumn
	} = useDomino();


	const {
		group,
		groupes
	} = useGroup();

	const {
		palettes
	} = useColor();

	const {
		selection
	} = useSetting();

	const getSelection = () => {
		let xMin = (selection.x1 > selection.x2 ? selection.x2 : selection.x1) * currentZoom;
		let xMax = (selection.x1 > selection.x2 ? selection.x1 : selection.x2) * currentZoom;
		let yMin = (selection.y1 > selection.y2 ? selection.y2 : selection.y1) * currentZoom;
		let yMax = (selection.y1 > selection.y2 ? selection.y1 : selection.y2) * currentZoom;


		let {
			column: columnMin,
			line: lineMin
		} = getLineAndColumn(xMin, yMin, false, currentZoom);


		let {
			column: columnMax,
			line: lineMax
		} = getLineAndColumn(xMax, yMax, false, currentZoom);

		return {
			columnMin,
			lineMin,
			columnMax,
			lineMax
		}
	}
	const goToSwitch = () => {
		switchColor({
			colorStart,
			colorEnd,
			selection: getSelection()
		}, () => {
			closeModal();
		});
	}

	const deleteColor = () => {
		switchColor({
			colorStart,
			colorEnd: 'delete',
			selection: getSelection()
		}, () => {
			closeModal();
		});
	}

	useEffect(() => {
		if (forceOpen && !isShowing) {
			return show();
		}
		if (!forceOpen && isShowing) {
			setColorStart(false);
			setColorEnd(false);
			hide();
		}
	}, [forceOpen, show, hide, isShowing]);

	let closeModal = () => {
		if (typeof props.setForceOpenOpen === 'function') {
			props.setForceOpenOpen(false);
		}
		hide();
	}

	let colorCodesStart = [];

	if (groupes && typeof groupes.map === 'function') {
		groupes.map((gr) => {
			if (gr.group.id === group.id) {
				gr.detail.map((cd) => {
					if (cd.color.code !== colorEnd.code) {
						return colorCodesStart.push(cd.color.code);
					}
				})
			}
		});
	}


	let colorCodesEnd = [];
	palettes && palettes[currentPalette] && palettes[currentPalette].colors.map((c) => {
		if (c.color !== colorStart.color) {
			return colorCodesEnd.push(c.color);
		}
	});

	const updateColor = (type, c) => {
		let idColor = false

		if (type === 'start') {
			groupes.map((gr) => {
				if (gr.group.id === group.id) {
					gr.detail.map((cd) => {
						if (cd.color.code === c) {
							idColor = cd.color.id;
						}
					})
				}
			});

		}
		if (type === 'end') {
			palettes[currentPalette].colors.map((col) => {
				if (col.color === c) {
					idColor = col.id;
				}
			})
		}

		if (idColor !== false) {
			let color = {
				color: c,
				id: idColor
			};
			if (type === 'start') {
				setColorStart(color);
			}
			if (type === 'end') {
				setColorEnd(color);
			}
		}
	}
	return (
		<Modal
			isShowing={isShowing}
			hide={closeModal}
			title={t('PopInSwitchColor.title')}
			closeButton={forceOpen ? true : false}
		>
			<div className="ModalChooseColorToSwitch">
				<div className="row">
					<div className="col-6">
						<label htmlFor="inputPassword4"
						       className="form-label">{t('PopInSwitchColor.colorReplace')}</label>
						<div
							className={'render-color' + (colorStart === false ? ' noColor' : '')}
							style={{
								backgroundColor: colorStart === false ? 'transparent' : colorStart.color
							}}
						></div>
						<GithubPicker
							colors={colorCodesStart}
							onChangeComplete={(color) => {
								updateColor('start', color.hex);
							}}
							triangle="hide"
						/>
						{colorStart !== false && (
							<button
								onClick={deleteColor}
								type="submit"
								className="btn btn-primary btn-delete"
							>
								{t('PopInSwitchColor.delete')}
							</button>
						)}

					</div>
					<div className="col-6">
						<label htmlFor="inputPassword4"
						       className="form-label">{t('PopInSwitchColor.colorSwitch')}</label>
						<div
							className={'render-color' + (colorEnd === false ? ' noColor' : '')}
							style={{
								backgroundColor: colorEnd === false ? 'transparent' : colorEnd.color
							}}
						></div>

						<div className="input-group">
							<select
								className="form-select"
								onChange={(evt) => {
									setCurentPalette(evt.target.value);
								}}
								value={currentPalette}
							>
								{palettes.map((pl, indexPalette) => {
									return (
										<option value={indexPalette} key={indexPalette}>{pl.name}</option>
									)
								})}
							</select>
						</div>

						<GithubPicker
							colors={colorCodesEnd}
							onChangeComplete={(color) => {
								updateColor('end', color.hex);
							}}
							triangle="hide"
						/>
					</div>
				</div>
				<div className="wrapper-btn-save">
					<button
						onClick={goToSwitch}
						type="submit"
						className="btn btn-primary btn-save"
					>
						{t('PopInSwitchColor.replace')}
					</button>
				</div>
			</div>
		</Modal>
	);
}

export default ModalChooseColorToSwitch;
